import type { TStyleWrapper } from '../type';

// Здесь делаем исключение, чтобы не добавлять правило из папки styles
// eslint-disable-next-line import/no-unassigned-import, import/no-internal-modules
import './styles/themeStyles/avito.scssGlobal';

export const AvitoStylesWrapper = ({ children }: TStyleWrapper) => children;
